import React, { Component } from 'react';
import WS from '../services/webservice';
import CadastroHelper from './CadastroHelper.js';

class CadastroTipoPagto extends Component {

  constructor(props) {
    super(props);
    this.state = {}

    this.ws = new WS();
  }

  componentWillUnmount() {
    clearInterval(this.timerId);
  }

  componentDidMount() {

  }

  render() {
    return (
      <CadastroHelper
        dados={{
          acessoID: 'b87b3032-f4be-4f2f-99af-834c5495a1ab',
          parentProps: this.props,
          id: "t05_cd_tp_pgto",
          tipo_cadastro: "Tipo de pagamento",
          tipo_plural: "pagamentos",
          href: "/tipo_pagto",
          titulo: "Cadastro de Tipos de Pagamentos",
          requests: {
            type: 'tipo_pagamento',
            list: this.ws.getTipo.bind(this.ws),
            save: this.ws.criarTipo.bind(this.ws),
            edit: this.ws.alterarTipo.bind(this.ws),
            delete: this.ws.deleteTipo.bind(this.ws),
          },
          campos: [
            {
              ref: "t05_prioridade",
              label: "Prioridade",
              type: "number",
              placeHolder: "Escreva a prioridade do tipo de pagamento",
            },
            {
              ref: "t05_sg_tp_pgto",
              label: "Sigla",
              maxLength: 3,
              type: "text",
              placeHolder: "Escreva a sigla do tipo de pagamento",
            },
            {
              ref: "t05_desc",
              label: "Descrição",
              type: "text",
              placeHolder: "Escreva a descrição do tipo de pagamento",
            },
            {
              ref: "t05_ativo",
              label: "Ativo",
              type: "checkbox",
            },
            {
              ref: "t05_iugu",
              label: "Iugu",
              type: "checkbox",
            },
            {
              ref: "tipo_voucher",
              label: "Tipo Voucher",
              type: 'voucher',
            },
          ],
          botoes: [
            {
              label: "Criar Tipo",
            },
          ],
          table: {
            colunas: [
              {
                Header: "Prioridade",
                accessor: "t05_prioridade",
                width: 80,
                Cell: row => (
                  <div
                    style={{
                      width: '16%',
                      height: '76%',
                      margin: '0 auto',
                    }}
                  >
                  {row.original.t05_prioridade}
                  </div>
                ),
              },
              {
                Header: "Ativo",
                accessor: "t05_ativo",
                width: 100,
                Cell: row => (
                  <div
                    style={{
                      width: '16%',
                      height: '76%',
                      margin: '0 auto',
                      backgroundColor: row.original.t05_ativo ? 'green' : 'red',
                      borderRadius: '2px'
                    }}
                  />
                ),
                filterMethod: (filter, row) => {
                  if (filter.value === "") {
                    return true;
                  }
                  if (filter.value === "true") {
                    return row[filter.id];
                  }
                  return !row[filter.id];
                },
                Filter: ({ filter, onChange }) =>
                  <select
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "100%" }}
                    value={filter ? filter.value : ""}
                  >
                    <option value="">Todos</option>
                    <option value="true">Ativado</option>
                    <option value="false">Desativado</option>
                  </select>
              },
              {
                Header: "Sigla",
                accessor: "t05_sg_tp_pgto",
                width: 100,
              },
              {
                Header: "Descrição",
                accessor: "t05_desc",
              },
            ],
          }
        }}
      />
    );
  }
}

export default CadastroTipoPagto;
